export default __webpack_public_path__ + "media/images/archetypes/pollster-c31c70b144de82ee4d9738a141325f46.png";